import React, { memo, useCallback, useEffect, useState } from 'react';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';

// 全局变量用于控制弹窗显示
let globalAlertVisible = false;
let globalAlertMessage = '';
let globalOnCloseCallback = () => {};

// 全局显示弹窗的方法
export const showTopAlert = (message, onPressBack) => {
  globalAlertVisible = true;
  globalAlertMessage = message;
  globalOnCloseCallback = onPressBack;
  // 触发更新
  if (updateAlert) {
    updateAlert(true);
  }
};

// 全局隐藏弹窗的方法
const hideTopAlert = () => {
  globalAlertVisible = false;
  if (updateAlert) {
    updateAlert(false);
  }
};

let updateAlert;

const TopAlert = memo(() => {
  const [isVisible, setIsVisible] = useState(globalAlertVisible);
  const [newMessage, setNewMessage] = useState({});
  updateAlert = setIsVisible;

  useEffect(() => {
    setIsVisible(globalAlertVisible);
    if (globalAlertVisible) {
      initData();
    }
  }, [globalAlertVisible]);
  useEffect(() => {
    if (!!Stores.AppMod.token) {
      initData();
    }
  }, []);
  const initData = useCallback(() => {
    Stores.AppMod.queryHeadMsgForPull().then((res) => {
      if (res) {
        setNewMessage(res);
        setIsVisible(true);
        setTimeout(() => {
          setNewMessage({});
          setIsVisible(false);
        }, 5000);
      }
    });
  }, []);

  if (!newMessage || !newMessage.id || !isVisible) {
    return null;
  }

  return (
    <div
      style={{ ...styles.container, ...styles.rowCC }}
      onClick={() => {
        console.log('click');
        setIsVisible(false);
        Stores.AppMod.handleMessageAction(newMessage);
        hideTopAlert();
        globalOnCloseCallback && globalOnCloseCallback(newMessage);
      }}>
      {!!newMessage.imageUrl && newMessage.imageUrl != '[]' && (
        <img
          round
          src={newMessage.imageUrl}
          style={{
            width: '112px',
            height: '112px',
            borderRadius: '12px'
          }}
        />
      )}

      <div
        style={{
          ...styles.rowColumn,
          ...{
            width: '100%',
            paddingLeft: 12,
            paddingRight: 12,
            overflow: 'hidden'
          }
        }}>
        <div
          style={{ ...styles.textTitle }}
          //   numberOfLines={1}
          // ellipsizeMode={'tail'}
        >
          {newMessage.title}
        </div>
        <div style={styles.textContent}>{newMessage.content}</div>
      </div>
      <img
        round
        src={`${CDN_BASE}/assets/imgs/shop/message/arrow-right.png`}
        style={{
          width: '48px',
          height: '48px'
        }}
      />
    </div>
  );
});

const styles = {
  container: {
    height: '160px',
    marginLeft: '24px',
    marginRight: '24px',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff', // 示例颜色，可按需调整
    padding: '24px',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderRadius: '24px',
    zIndex: 9999,
    'box-shadow': '0px 8px 16px 0px rgba(0,0,0,0.12)',
    border: '1px solid #EEEEEE'
  },
  textTitle: {
    color: '#333',
    fontSize: '28px',
    fontWeight: 'bold',
    flexWrap: 'wrap',
    'white-space': 'nowrap' /* 防止文本换行 */,
    overflow: 'hidden' /* 隐藏超出的内容 */,
    'text-overflow': 'ellipsis' /* 在文本溢出时显示省略号 */
  },
  textContent: {
    color: '#666',
    fontSize: '24px',
    lineHeight: '26px',
    flexWrap: 'wrap',
    marginTop: '4px',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    'text-overflow': 'ellipsis',
    '-webkit-line-clamp': '2'
  },
  closeText: {
    color: '#fff'
  },
  rowCC: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  rowColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
};

export default TopAlert;



// WEBPACK FOOTER //
// ./src/components/Message/headerAlert.js